export default "__VITE_ASSET__CkWeT19y__"